import { Layout, Building2, MapPin, Check } from "lucide-react";
import { Rich } from "@/components/Rich";
import { withDefaults } from "@/lib/sections";

const CARD_META = [
  { id: "landing", icon: Layout, accent: "sky" },
  { id: "corporate", icon: Building2, accent: "orange", featured: true },
  { id: "local-seo", icon: MapPin, accent: "sky" },
];

export default function Services({ content }) {
  const c = withDefaults("services", content);
  const SERVICES = (c.cards || []).slice(0, 3).map((card, i) => ({ ...CARD_META[i], ...card, items: card.items || [] }));
  const goTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section
      id="servicios"
      data-testid="section-services"
      className="relative py-20 sm:py-28 border-t border-slate-900"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <div className="font-mono text-xs text-sky-400 mb-3">
            {c.eyebrow}
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-white">
            <Rich text={c.title} />
          </h2>
          <p className="mt-4 text-slate-400 text-lg">
            {c.subtitle}
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {SERVICES.map((s) => {
            const Icon = s.icon;
            const isOrange = s.accent === "orange";
            return (
              <article
                key={s.id}
                data-testid={`service-card-${s.id}`}
                className={`group relative rounded-2xl border bg-slate-900/60 p-7 transition-all duration-300 hover:-translate-y-1 ${
                  s.featured
                    ? "border-orange-500/40 shadow-[0_0_30px_-10px_rgba(249,115,22,0.4)]"
                    : "border-slate-800 hover:border-sky-500/40"
                }`}
              >
                {s.featured && (
                  <span
                    className="absolute -top-3 left-7 px-3 py-1 text-xs font-semibold rounded-full bg-orange-500 text-white"
                    data-testid="service-featured-badge"
                  >
                    Más popular
                  </span>
                )}
                <div
                  className={`inline-flex items-center justify-center w-12 h-12 rounded-xl border ${
                    isOrange
                      ? "bg-orange-500/10 border-orange-500/30 text-orange-400"
                      : "bg-sky-500/10 border-sky-500/30 text-sky-400"
                  }`}
                >
                  <Icon size={22} />
                </div>
                <h3 className="mt-5 text-xl font-semibold text-white">
                  {s.title}
                </h3>
                <p
                  className={`font-mono text-xs mt-1 ${
                    isOrange ? "text-orange-400" : "text-sky-400"
                  }`}
                >
                  // {s.tagline}
                </p>
                <p className="mt-3 text-slate-400 text-sm leading-relaxed">
                  {s.desc}
                </p>

                <ul className="mt-6 space-y-2.5">
                  {s.items.map((item, i) => (
                    <li
                      key={i}
                      className="flex items-start gap-2 text-sm text-slate-300"
                    >
                      <Check
                        size={16}
                        className={`mt-0.5 shrink-0 ${
                          isOrange ? "text-orange-500" : "text-sky-500"
                        }`}
                      />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>

                <button
                  onClick={() => goTo("cotizador")}
                  data-testid={`service-cta-${s.id}`}
                  className={`mt-7 w-full py-3 rounded-lg font-semibold text-sm transition-all ${
                    isOrange
                      ? "bg-orange-500 hover:bg-orange-600 text-white"
                      : "bg-slate-800 hover:bg-slate-700 text-sky-300 border border-slate-700 hover:border-sky-500/40"
                  }`}
                >
                  Cotizar este paquete
                </button>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
